module.exports = __webpack_public_path__ + "static/media/logo.d5a91607.png";